<template>
  <base-section
    id="camera-ready"
    :space="0"
  >
<v-container>
      <div>
        <v-tabs
          id="tab-cameraready"
        >
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-scientific`"
            @click="goToTop"
          >
            Scientific Papers
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-special`"
            @click="goToTop"
          >
            Special Tracks Papers
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-industrial`"
            @click="goToTop"
          >
            Industrial Papers
          </v-tab>
          <v-tab-item
            :value="`tab-scientific`"
          >
            <camera-ready-scientific />
          </v-tab-item>
          <v-tab-item
            :value="`tab-special`"
          >
            <camera-ready-special />
          </v-tab-item>
          <v-tab-item
            :value="`tab-industrial`"
          >
            <camera-ready-industrial />
          </v-tab-item>
        </v-tabs>
      </div>
    </v-container>
  </base-section>
</template>

<script>
import CameraReadyIndustrial from './CameraReadyIndustrial.vue'
import CameraReadyScientific from './CameraReadyScientific.vue'
import CameraReadySpecial from './CameraReadySpecial.vue'
  export default {
  components: { CameraReadyScientific, CameraReadySpecial, CameraReadyIndustrial },
    name: 'CameraReady',

    data () {
    return {
      isMobile: false,
    }
    },
    mounted () {
      document.getElementById('tab-cameraready').firstChild.style = 'position: fixed; background-color: #fafafa !important; width = 100%; margin-top: -11px; z-index: 5; width: 100%;'
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      goToTop () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
    },
  }
</script>
